var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:[_vm.$style.input, _vm.error && _vm.$style.error],attrs:{"type":_vm.password ? 'password' : 'text',"disabled":_vm.disabled,"maxlength":_vm.maxlength},on:{"input":function($event){return _vm.update()},"change":function($event){return _vm.update()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }